import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Grid,
    TextField,
} from '@material-ui/core';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import { CompanyModel } from '../../../Models/CompanyModel';
import InfluencerModelField from './InfluencerModelField';
import { AuthContext } from '../../Authentication/AuthContext';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';


type Props = {
    open: boolean;
    onClose: () => void;
    influencer: CompanyModel | undefined;
    filters: InfluencersAuxiliarResponse | undefined;
};

function formatDateTime(dateString?: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function formatDate(dateString?: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}
export default function CompanyDetailModal({ open, onClose, influencer, filters }: Props) {
    const authContext = React.useContext(AuthContext);
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                style: {
                    borderRadius: 12,
                    padding: '1rem',
                },
            }}
        >
            <DialogTitle disableTypography>
                <Typography variant="h6">Detalhe Empresas/Evento/Patrocínio</Typography>
                <Typography variant="subtitle1">{influencer?.nome}</Typography>
            </DialogTitle>

            <DialogContent dividers style={{ paddingTop: 16, paddingBottom: 16 }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Responsável Reputação" value={influencer?.responsavelReputacao} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nome Solicitante" value={influencer?.solicitante} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="E-mail" value={influencer?.email} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Data" value={formatDateTime(influencer?.dataRecebimento)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Marca" value={influencer?.marca} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Área" value={influencer?.area} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="VP" value={influencer?.vp} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nome Empresa/Evento" value={influencer?.nome} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Site da Empresa/Evento" value={influencer?.siteEmpresa} />
                    </Grid>

                    <Grid item xs={4}>
                        <InfluencerModelField
                            label="Tipo de relacionamento/patrocínio"
                            value={filters?.tipo_relacionamento.find((item) => item.id_aux === influencer?.tipoRelacionamento)?.descricao}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Objetivo/conceito da iniciativa" value={influencer?.objetivo} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Inicio do Periodo da Ação" value={formatDate(influencer?.periodoAcao)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Fim do Periodo da Ação" value={formatDate(influencer?.periodoAcaoFim)} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Já foi ou é uma parceira GB?" value={influencer?.parceiraGB == 1 ? 'Sim' : 'Não'} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Haverá divulgação sobre a parceria?" value={Number(influencer?.divulgacaoParceria) === 1 ? 'Sim' : 'Não'} />
                    </Grid>
                    <Grid item xs={12}>
                        <InfluencerModelField label="Observações" value={influencer?.observacoes} multiline
                            minRows={5} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField
                            label="Canais de Divulgação"
                            value={
                                influencer?.canaisId
                                    ?.map((canal) =>
                                        filters?.canais.find((f) => f.id_aux === canal.id_aux)?.descricao
                                    )
                                    .filter(Boolean) // remove undefined
                                    .join(', ') // junta em uma string
                            }
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Abrangência" value={influencer?.abrangencia} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfluencerModelField label="Nível de Risco" value={influencer?.nivelRisco} />
                    </Grid>
                    <Grid item xs={12}>
                        <InfluencerModelField label="Análise Reputacional" value={influencer?.analiseReputacional}
                            multiline
                            minRows={5} />
                    </Grid>

                </Grid>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: 8, textTransform: 'none' }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog >
    );
}
